import { useEffect } from 'react';
import { useCrawlersStore } from '../stores/crawlers.store';

export const useCrawlers = () => {
  const store = useCrawlersStore();
  const load = useCrawlersStore((state) => state.load);

  useEffect(() => {
    load();
  }, [load]);

  return store;
};
